<template>
  <svg width="42" height="42" xmlns="http://www.w3.org/2000/svg"><g
    transform="translate(3)"
    :stroke="fillColor"
    fill="none"
    fill-rule="evenodd"
  ><path d="m4.541 32.919 26.108 4.54M21.568 13.622l9.081 21.567M21.568 13.622 34.054 0M21.568 13.622 5.676 34.054M21.568 13.622 0 5.676" /><circle
    fill="#FFF"
    fill-rule="nonzero"
    cx="4.541"
    cy="34.054"
    r="3.405"
  /><circle
    fill="#FFF"
    fill-rule="nonzero"
    cx="29.514"
    cy="38.595"
    r="3.405"
  /><circle
    fill="#FFF"
    fill-rule="nonzero"
    cx="21.568"
    cy="13.622"
    r="3.405"
  /></g></svg>
</template>

<script>
export default {
  name: 'LocationsSVG',
  props: {
    fillColor: {
      type: String,
      default: '#FF6741'
    }
  }
}
</script>
